import {client} from '../helpers/api';

export async function getDownloadTimeTable() {
  const response = await client.get('/api/download-timetable');

  if (response.data?.status) {
    return response.data?.data?.link;
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}

// {
//   status: true,
//   data: {
//     link:
//       'https://userdata-startutor.s3.amazonaws.com/class-timetable/6cf4b841-c3d3-4f3e-8541-17e27936365a.pdf?ver=c904c280-217a-496d-91dc-270edf66c3fa',
//   },
// }
